import { NgModule, ModuleWithProviders, Optional, SkipSelf } from '@angular/core';
import { FnCurrencyDirective } from './directives/fn-currency.directive';
import { FnNumberDirective } from './directives/fn-number.directive';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FnInputValidator } from './directives/fn-input-validator';
import { FnTranslateModule } from '../i18n/index';
import { FnTemperatureDirective } from './directives/fn-temperature.directive';
import { FnAutoFocusDirective } from './directives/fn-autofocus.directive';
import { FnAppendToDirective } from './directives/fn-appendTo.directive';

export * from '../core/model/fn-form.constant';
export * from '../core/model/fn-input.model';
export * from '../core/model/fn-input.value.accessor';
export * from '../core/model/fn-validator';

export * from '../core/directives/fn-currency.directive';
export * from '../core/directives/fn-number.directive';
export * from '../core/directives/fn-input-validator';
export * from '../core/directives/fn-autofocus.directive';
export * from '../core/directives/fn-appendTo.directive';
export * from '../core/directives/fn-temperature.directive';

/** 
 * Exports the required FnNumberDirective to allow only number in input field,FnCurrencyDirective to allow numbers like currency types in input field
 * and FnInputValidator to validate text in  input field.
 * making them available for import by NgModules that import this module.
 */
@NgModule({
	declarations: [
		FnNumberDirective,
		FnCurrencyDirective,
		FnInputValidator,
		FnTemperatureDirective,
		FnAutoFocusDirective,
		FnAppendToDirective,
        FnTemperatureDirective
	],
	imports: [FormsModule, CommonModule, FnTranslateModule],
	exports: [
		FnNumberDirective,
		FnCurrencyDirective,
		FnInputValidator,
		FnTemperatureDirective,
		FnAutoFocusDirective,
		FnAppendToDirective
	],
	providers: [],
})
export class FnCoreModule {
    constructor(@Optional() @SkipSelf() parentModule: FnCoreModule) {
        if (parentModule) {
            throw new Error(
                'FnCoreModule is already loaded. Import it in the  AppModule(Root Module) only');
        }
    }

    static forRoot(): ModuleWithProviders<FnCoreModule> {
        return {
            ngModule: FnCoreModule,
            providers: []
        };
    }

}

